import axios from "axios";

export default axios.create({
    baseURL: "https://erdk.online/api",
    withCredentials: true,
})